export const APP_DETAILS = "APP_DETAILS";

export const BANK_DETAILS = "BANK_DETAILS";

export const BANNERS = "BANNERS";
export const ACTIVE_AUTH_MODAL = "ACTIVE_AUTH_MODAL";
export const AGENT_CODE = "AGENT_CODE";
